import React, {FC} from 'react';
import {AsyncPaginate} from 'react-select-async-paginate';
import { api } from '@/api';
import { TLabelAndValue } from '@/types';
import {defaultStyles} from '../../apps/Applications/consts';
import {IManualStock} from './interfaces';
import {SIDEBAR_TYPES, TYPES} from '../../apps/Applications/components/ModalPayCertificateOrDeposit/const';

const ManualStock: FC<IManualStock> = ({ 
  onChangeSelect, 
  type, 
  side, 
  classNameBlock, 
  user_id, 
  tariff_rate, 
  value, 
  isDisabled, 
  activeSideBarItem, 
  activeHeaderItem 
}) => {
    const loadOptions = async () => {
      let sideType: number

      if( type === 'order'){
        sideType = side
      } else if(activeSideBarItem !== undefined) {
        sideType = activeSideBarItem === SIDEBAR_TYPES.HYBRID ? SIDEBAR_TYPES.HYBRID : activeSideBarItem
      }else{
        return { options:[] };
      }
      
        const response = await api.tariff.getManualStock({
          side: sideType ,
          user_id,
          tariff_rate: activeHeaderItem === TYPES.CERTIFICATES ? undefined : tariff_rate,
        });
        const options: TLabelAndValue[] = response.map((item) => {
          return {
            value: item.id,
            label: item.title,
          };
        });
        return { options };
    };
    return (
        <AsyncPaginate
            className={classNameBlock}
            onChange={onChangeSelect}
            isClearable
            value={value}
            isDisabled={isDisabled}
            placeholder='Выберите'
            loadOptions={loadOptions}
            styles={defaultStyles}
            noOptionsMessage={() => 'Ничего не найдено'}
            loadingMessage={() => 'Поиск...'}
        />
    );
};

export default ManualStock;